import { ptBR } from "date-fns/locale";
import { format } from "date-fns";

export const locale = { locale: ptBR };

export function formatDefault(date: Date | number) {
    return format(date, `dd/MM/yyy`, locale);
}

export function formatEqualsFB(date: Date | number) {
    return format(date, `yyyy-MM-dd`, locale);
}

export function formatDateMiddle(date: Date | number) {
    return format(date, `dd/MM`, locale);
}

export function formatDay(date: Date | number) {
    return format(date, `EEEE`, locale);
}

export function formatTimestamp(date: Date | number) {
    return format(date, `T`, locale);
}

export function formatByPhrase(date: Date | number) {
    return format(date, "'Dia:' dd/MM/yyyy 'às' h:mm:ss aaa", locale);
}
